export const API_TOKEN = "80dc9abb5bdc994ed5c1e7e982e8ae3d395df5736964dd9316f076e0c75c39bce137359c45959c9c5667d85f8a3a4a1ed42944a15b3963b7c81223031cb20e2a87b419b5f0e2aba0c69a7c3a63419a13ed88d66dd5c45e6eeb9182ab5becafbae9c9ef3dd841ef52151886e3cabcd708367e6058fbaf357143114b70e47ec46b"
export const MAIN_ADDRESS = "http://localhost:1337"
export const API_ADDRESS = MAIN_ADDRESS + "/api"
export const HEADERS = {
    Authorization: `Bearer ${API_TOKEN}`
}